'use strict';

const formValidation = require('base/components/formValidation');
var $tokenCodeInputs = $('input[name^="tokenDigit-"]');
var isTokenFormSubmitting = false;
var tealiumEnable = require('int_tealium_sfra/tealiumEnable');
var utils = require('base_global/utils');

/**
 * update modal contents after ajax call
 * @param {Object} data - response object
 */
const updateModalContents = (data, $currEle) => {
    $('.request-passwordless-login-title').text(data.receivedMsgHeading || '');
    $('.request-passwordless-login-body').empty().append(data.receivedMsgBody || '');

    if (data.buttonText && data.redirectUrl) {
        if (data.showTokenForm) {
            $('.passwordless-form')
                .off('submit')
                .removeClass('passwordless-form')
                .addClass('passwordless-token-form')
                .attr('action', data.redirectUrl);
            if (data.usid) {
                $('.passwordless-token-form').data('usid', data.usid);
            }
            if (data.email) {
                $('.passwordless-token-form').data('email', data.email);
            }
            $('.send-passwordless-email-btn')
                .empty()
                .html(
                    `<button type="submit" id="submitTokenButton"
                        class="btn btn-primary btn-block">
                    ${data.buttonText}</button>`);
            $tokenCodeInputs = $('input[name^="tokenDigit-"]');
            module.exports.digitsOnly();
            module.exports.autoAdvanceToken();
            module.exports.moveFocusOnClear();
            module.exports.handlePasteEvent();
            module.exports.submitPwdlessTokenForm();
            if ($currEle && $currEle.length) {
                $currEle.find('.request-passwordless-container').removeClass('d-none');
                $currEle.find('.login-page').addClass('pwdless-open');
            }
        } else {
            $('.send-passwordless-email-btn')
                .empty()
                .html(
                    `<a href="${data.redirectUrl}" class="btn btn-primary btn-block">
                ${data.buttonText}
            </a>`);
        }
    } else {
        $('.send-passwordless-email-btn').empty().html('');
    }
    if ($currEle && $currEle.length) {
        $currEle.find('.login-page').addClass('pwdless-open');
        $currEle.find('.request-passwordless-container').removeClass('d-none');
        $currEle.find('.request-passwordless-container').focus();
    }
};

/**
 * update modal contents after ajax call
 * @param {Object} data - response object
 */
const updateResendModalContents = (data) => {
    if (data.showTokenForm && data.success) {
        $('.pwdless-resendcode').addClass('d-none');
        $('.pwdless-resendCodeText').removeClass('d-none');
        // Reset the message back to "Resend Code" after a few seconds
        setTimeout(() => {
            $('.pwdless-resendcode').removeClass('d-none');
            $('.pwdless-resendCodeText').addClass('d-none');
        }, 10000);
    } else {
        $('.pwdless-resendcode').removeClass('d-none');
        $('.pwdless-resendCodeText').addClass('d-none');
    }
};

/**
 * Create an alert to display the error message
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml = '<div class="alert ds-alert--error" role="alert">' +
        '<span class="icon-alert"></span>' +
        '<span class="error-message">' + message + '</span>' +
        '</div>';

    $('.error-messaging').empty().append(errorHtml);
};

const getTokenValue = function () {
    var token = '';
    $tokenCodeInputs.each(function () {
        token += $(this).val();
    });
    return token;
};

const submitTokenForm = function (currentform) {
    if (isTokenFormSubmitting) return;
    var token = getTokenValue();
    if (token.length === 8) {
        isTokenFormSubmitting = true;
        // Remove focus from all input fields
        $tokenCodeInputs.blur();
        $(currentform).closest('.passwordless-token-form').submit();
    }
};

module.exports = {
    submitPwdlessForm: function () {
        $(document).on('click', '.passwordless-code', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            // $('.form-email-error').empty();
            $('#login-form-email, #login-form-password').removeClass('error is-invalid');
            var $currEle = $(this).closest('.ds-login-panel-modal, .ds-user-signin, .order-track-section');
            var form = $('form.login').length ? $currEle.find('form.login') : $('form.returningCustomerForm');
            form.find('.alert-danger').empty();
            if ($('.ds-login-panel-modal .btn-login', '.ds-user-signin .btn-login').hasClass('d-none')) {
                $('.password-field-group, .ds-colum-action-item').addClass('d-none');
            }
            var custemail = $('#login-form-email').val();
            var fromModal = $('.ds-login-panel-modal').hasClass('show-signIn') ? true : false;
            var defer = $.Deferred(); // eslint-disable-line
            if (form.find('#form-email-error').is(':visible') || form.find('input#login-form-email, input#RC-login-form-email').val() === '') {
                form.find('#login-form-email, input#RC-login-form-email').addClass('error is-invalid');
                if (form.find('input#login-form-email, input#RC-login-form-email').val().trim() === '') {
                    form.find('#form-email-error').text('The email field cannot be blank.').show();
                }
                tealiumEnable.getAnalyticsData('accountLoginErrorMsg', 'passwordlessLogin', false, fromModal);
                defer.reject(); // Reject the promise to avoid leaving it in a pending state
                return defer;
            }
            var $this = $(this);
            var url = $this.data('url');
            form.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize() + '&source=form',
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                        // $('.ds-login-panel-modal form.login', '.ds-user-signin form.login', 'form.returningCustomerForm').trigger('login:error', data);
                        form.trigger('login:error', data);
                        $('.alert-danger').append('<span class="icon-alert"></span>');
                        form.find('#login-form-email', 'input#RC-login-form-email').addClass('error is-invalid');
                        form.siblings('.acccount-create-msg-container, .order-history-navigation-view').hide();
                        var fromModal = $('.ds-login-panel-modal').hasClass('show-signIn') ? true : false;
                        tealiumEnable.getAnalyticsData('creatPasswordLessAccountAndLoginEvent', 'login_failure', false, fromModal, custemail);
                    } else {
                        $('.pwdless-resendcode').removeClass('d-none');
                        $('.pwdless-resendCodeText').addClass('d-none');
                        form.find('.alert-danger').hide();
                        if (!$currEle.find('.modal-tab-container').length) {
                            form.siblings('.acccount-create-msg-container, .order-history-navigation-view').show();
                        }
                        form.find('#login-form-email, #RC-login-form-email, #login-form-password, #RC-login-form-password').removeClass('error is-invalid');
                        updateModalContents(data, $currEle);
                        var fromModal = $('.ds-login-panel-modal').hasClass('show-signIn') ? true : false;
                        tealiumEnable.getAnalyticsData('creatPasswordLessAccountAndLoginEvent', 'login', false, fromModal, custemail);
                    }
                    if (data.accountLocked) {
                        window.location.href = data.redirectUrl;
                    }
                },
                error: function () {
                    form.spinner().stop();
                }
            });
            return false;
        });
    },

    selectPwdlessLogin: function () {
        $(document).on('click', '.btn-pwdless-select-login', function (e) {
            e.preventDefault();
            var form = $('.passwordless-form');
            $('.alert', form).remove();
            $.spinner().start();
            $.ajax({
                url: $(this).attr('href'),
                type: 'post',
                dataType: 'json',
                data: {
                    login: $(this).data('login'),
                    csrf_token: $('input[name="csrf_token"]', form).val(),
                    source: 'select-modal'
                },
                success: function (data) {
                    $.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        updateModalContents(data);
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
            return false;
        });
    },

    submitPwdlessTokenForm: function () {
        $('.passwordless-token-form').off('submit').on('submit', function (e) {
            e.preventDefault();
            var custemail = $('.passwordless-token-form').data('email');
            var form = $(this);
            const token = getTokenValue();
            var currentLocation = $(location).attr('pathname');
            var searchLogin = form.data('content-login');
            var searchCreateAccount = form.data('content-register');
            var confirmationPage = form.data('content-confirm');
            var trouleShootPage = form.data('content-troubleshootpage');
            var cartPage = form.data('content-cart');
            var checkoutPage = form.data('content-checkout');
            var sessionTimeoutPage = form.data('content-sessiontimeout');
            var lastVisitedPage = $('#lastVisitedPath').val();
            var confirmationApplePayPage = form.data('content-applepayconfirm');
            var signinPage = form.data('loginpage');
            var isSignedInFromCheckoutButton = $('.initiate-checkout_js').data('lastclicked') || utils.getQueryStringParams(window.location.href).login;
            var hasBasketMergedAfterLogin = false;
            var cartMergeUrl;
            form.spinner().start();
            $.ajax({
                url: form.attr('action'),
                type: 'post',
                dataType: 'json',
                data: {
                    source: 'ajax',
                    token: token,
                    usid: form.data('usid'),
                    loginEmail: form.data('email'),
                    rurl: $('.pwdless-data-container').data('reentry-endpoint')
                },
                success: function (data) {
                    form.spinner().stop();
                    isTokenFormSubmitting = false;
                    if (!data.success) {
                        createErrorNotification(data.error);
                        $('.pwdless-token').addClass('token-error');
                        $('.error-messaging').show();
                        updateResendModalContents(data);
                        var fromModal = $('.ds-login-panel-modal').hasClass('show-signIn') ? true : false;
                        tealiumEnable.getAnalyticsData('creatPasswordLessAccountAndLoginEvent', 'loginotp_failure', false, fromModal, custemail);
                    }
                    if (data.success && data.redirectUrl) {
                        var fromModal = $('.ds-login-panel-modal').hasClass('show-signIn') ? true : false;
                        tealiumEnable.getAnalyticsData('creatPasswordLessAccountAndLoginEvent', 'loginotp_success', false, fromModal, custemail);
                        $('.pwdless-token').removeClass('token-error');
                        $('.error-messaging').hide();
                        updateResendModalContents(data);
                        if (data.isBasketMerged) {
                            hasBasketMergedAfterLogin = true;
                            cartMergeUrl = `${cartPage}?basketMerged=true`;
                        }
                        if (currentLocation === searchLogin || currentLocation === searchCreateAccount || currentLocation === confirmationPage || currentLocation === trouleShootPage || currentLocation === confirmationApplePayPage || currentLocation === signinPage) {
                            location.href = data.redirectUrl;
                        } else if (currentLocation === cartPage && isSignedInFromCheckoutButton && data.success) { // eslint-disable-line
                            if ($('#siteName').val() === 'pvhckca') {
                                var checkoutURL = $('.btnCheckout').data('url');
                                checkoutURL += '?isCheckoutSignedIn=true';
                                $('.btnCheckout').attr('data-url', checkoutURL);
                                $('.btnCheckout').trigger('click');
                            } else if (isSignedInFromCheckoutButton) {
                                let queryParam = utils.getQueryStringParams(window.location.href);
                                if (queryParam.paymentMethod === 'expressPayment') {
                                    window.location.href = $('.initiate-checkout_js').data('cartpage');
                                } else {
                                    location.href = checkoutPage;
                                }
                            }
                        } else if (currentLocation === checkoutPage) {
                            // if the basket items where merged upon login , go back to cart
                            if (hasBasketMergedAfterLogin) {
                                location.href = cartMergeUrl;
                                return;
                            }
                            location.href = `${checkoutPage}?stage=shipping`;
                        } else if (currentLocation === sessionTimeoutPage) {
                            var lastVisitedUrl = lastVisitedPage !== 'null' && !lastVisitedPage.includes('Checkout-SessionTimeout') ? encodeURIComponent(lastVisitedPage) : encodeURIComponent(document.referrer);
                            window.location.href = decodeURIComponent(lastVisitedUrl);
                        } else if (currentLocation === cartPage && hasBasketMergedAfterLogin) {
                            window.location.href = cartMergeUrl;
                        } else {
                            window.location.reload();
                        }
                        if (currentLocation === cartPage) {
                            history.replaceState({}, '', window.location.pathname);
                        }
                    }
                },
                error: function () {
                    form.spinner().stop();
                    isTokenFormSubmitting = false;
                }
            });
            return false;
        });
    },

    resendCode: function () {
        $(document).on('click', '.pwdless-resendcode', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var $this = $(this);
            var $currEle = $(this).closest('.ds-login-panel-modal, .ds-user-signin, .order-track-section');
            var form = $('form.login').length ? $currEle.find('form.login') : $('form.returningCustomerForm');
            var custemail = $('.passwordless-token-form').data('email');
            $this.spinner().start();
            $.ajax({
                url: $this.attr('href'),
                type: 'post',
                dataType: 'json',
                data: form.serialize() + '&source=form',
                success: function (data) {
                    $this.spinner().stop();
                    if (!data.success) {
                        updateResendModalContents(data);
                    } else {
                        updateModalContents(data, $currEle);
                        updateResendModalContents(data);
                    }
                    var fromModal = $('.ds-login-panel-modal').hasClass('show-signIn') ? true : false;
                    tealiumEnable.getAnalyticsData('creatPasswordLessAccountAndLoginEvent', 'loginotp_resend', false, fromModal, custemail);
                },
                error: function () {
                    $this.spinner().stop();
                }
            });
            return false;
        });
    },

    // Only allow digits to be entered
    digitsOnly: function () {
        $tokenCodeInputs.on('input', function () {
            this.value = this.value.replace(/[^0-9]/g, '');
        });
    },

    autoAdvanceToken: function () {
        $tokenCodeInputs.on('input keydown', function (e) {
            // Handle input event to auto-advance
            if (e.type === 'input' && this.value.length === 1) {
                let nextInput = $(this).closest('div').next().find('input');
                if (nextInput.length) {
                    nextInput.focus();
                } else {
                    // If it's the last input, trigger the submission process
                    submitTokenForm(this);
                }
            }

            // Prevent default behavior for Tab key only if necessary
            if (e.type === 'keydown' && e.key === 'Tab') {
                e.preventDefault();
                let nextInput = $(this).closest('div').next().find('input');
                if (nextInput.length) {
                    nextInput.focus();
                } else {
                    // If no more inputs, trigger the submission process
                    // submitTokenForm();
                    $('.pwdless-resendcode').focus();
                }
            }
        });
    },

    moveFocusOnClear: function () {
        $tokenCodeInputs.on('keydown', function (e) {
            var prevInput;
            var nextInput;
            // Handle Backspace key
            if (e.keyCode === 8 && this.value.length === 0) { // Backspace key
                prevInput = $(this).closest('div').prev().find('input');
                if (prevInput.length) {
                    prevInput.focus();
                    prevInput.val(''); // Clear the previous input
                }
            }

            // Handle ArrowLeft key
            if (e.key === 'ArrowLeft') {
                prevInput = $(this).closest('div').prev().find('input');
                if (prevInput.length) {
                    prevInput.focus();
                }
            }
            // Handle ArrowRight key
            if (e.key === 'ArrowRight') {
                nextInput = $(this).closest('div').next().find('input');
                if (nextInput.length) {
                    nextInput.focus();
                }
            }
            // Handle Shift + Tab key
            if (e.key === 'Tab' && e.shiftKey) {
                e.preventDefault(); // Prevent default Shift + Tab behavior
                prevInput = $(this).closest('div').prev().find('input');
                if (prevInput.length) {
                    prevInput.focus();
                }
            }
        });
    },

    handlePasteEvent: function () {
        $tokenCodeInputs.on('paste', function (e) {
            e.preventDefault();
            const visibleInputs = $tokenCodeInputs.filter(':visible');
            const rawData = e.originalEvent.clipboardData.getData('text');
            const pastedData = typeof rawData === 'string' ? rawData.trim() : String(rawData).trim();
            const slicedData = pastedData.slice(0, visibleInputs.length);

            for (let i = 0; i < visibleInputs.length; i++) {
                visibleInputs.eq(i).val(slicedData.charAt(i) || '');
            }

            const allFilled = [...visibleInputs].every(input => $(input).val().length === 1);
            if (allFilled) {
                setTimeout(() => {
                    visibleInputs.blur();
                    $('.pwdless-resendcode').focus();
                    requestAnimationFrame(() => {
                        submitTokenForm(this); // Run this after browser paints
                    });
                }, 0);
            }
        });
    },

    clickPwdEmailReturnBtn: function () {
        $(document).on('click', '.btn-returnSingningWithPassword', function (e) {
            e.preventDefault();
            $(this).parents('.login-page').removeClass('pwdless-open');
            $('.request-passwordless-container').addClass('d-none');
        });
    },
    removeBasketMergedQueryParam: function () {
        var currentUrl = window.location.href;
        if (currentUrl.indexOf('basketMerged=true') > -1) {
            window.history.replaceState({}, '', window.location.pathname); // Update the URL without reloading the page
        }
    }
};
